module.exports = __webpack_public_path__ + "img/fc-logo.9a558712.png";